import * as genresAPI from "./fakeGenreService";

const movies = [
  {
    _id: 1,
    title: "Coming to America",
    genre: { _id: 1, name: "Comedy" },
    numberInStock: 6,
    dailyRentalRate: 2.5,
    publishDate: "2022-01-03T19:04:28.809z",
    liked: true
  },
  {
    _id: 2,
    title: "The 100",
    genre: { _id: 2, name: "science fiction" },
    numberInStock: 5,
    dailyRentalRate: 4.6,
    publishDate: "2022-01-03T19:04:28.809z",
    liked: true
  },
  {
    _id: 3,
    title: "Die Hard",
    genre: { _id: 3, name: "Thriller" },
    numberInStock: 8,
    dailyRentalRate: 3.5,
    publishDate: "2022-01-03T19:04:28.809z",
    liked: true
  },
  {
    _id: 4,
    title: "Trip to Italy",
    genre: { _id: 4, name: "Comedy" },
    numberInStock: 7,
    dailyRentalRate: 3.5,
    publishDate: "2022-01-03T19:04:28.809z",
    liked: true
  },
  {
    _id: 5,
    title: "Game of thrones",
    genre: { _id: 5, name: "Fantasy" },
    numberInStock: 7,
    dailyRentalRate: 3.5,
    publishDate: "2022-01-03T19:04:28.809z",
    liked: true
  },
  {
    _id: 6,
    title: "Wedding Crashers",
    genre: { _id: 6, name: "Comedy" },
    numberInStock: 7,
    dailyRentalRate: 3.5,
    publishDate: "2022-01-03T19:04:28.809z",
    liked: true
  },
  {
    _id: 7,
    title: "Gone Girl",
    genre: { _id: 7, name: "Thriller" },
    numberInStock: 7,
    dailyRentalRate: 4.5,
    publishDate: "2022-01-03T19:04:28.809z",
    liked: true
  },
  {
    _id: 8,
    title: "The Sixth Sense",
    genre: { _id: 8, name: "Thriller" },
    numberInStock: 4,
    dailyRentalRate: 3.5,
    publishDate: "2022-01-03T19:04:28.809z",
    liked: true
  },
  {
    _id: 9,
    title: "The Avengers",
    genre: { _id: 9, name: "Action" },
    numberInStock: 7,
    dailyRentalRate: 3.5,
    publishDate: "2022-01-03T19:04:28.809z",
    liked: true
  },
  {
    _id: 10,
    title: "Commando",
    genre: { _id: 10, name: "Action" },
    numberInStock: 3,
    dailyRentalRate: 4.5,
    publishDate: "2022-01-03T19:04:28.809z",
    liked: true
  },
  {
    _id: 11,
    title: "Flash",
    genre: { _id: 11, name: "science fiction" },
    numberInStock: 4,
    dailyRentalRate: 4.7,
    publishDate: "2022-01-03T19:04:28.809z",
    liked: false
  },
  {
    _id: 12,
    title: "Aladdin",
    genre: { _id: 12, name: "fantasy" },
    numberInStock: 4,
    dailyRentalRate: 4.2,
    publishDate: "2022-01-03T19:04:28.809z",
    liked: false
  }
];

export function getMovies() {
  return movies;
}

export function getMovie(id) {
  return movies.find((m) => m._id === id);
}
export function saveMovie(movie) {
  let movieInDb = movies.find((m) => m._id === movie._id) || {};
  movieInDb.title = movie.title;
  movieInDb.genre = genresAPI.genres.find((g) => g._id === movie.genreId);
  movieInDb.numberInStock = movie.numberInStock;
  movieInDb.dailyRentalRate = movie.dailyRentalRate;

  if (!movieInDb._id) {
    movieInDb._id = Date.now().toString();
    movies.push(movieInDb);
  }
  return movieInDb;
}
